import { NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, Landmark, Receipt, Percent, MoreHorizontal } from "lucide-react";
import { cn } from "@/lib/utils";

const TABS = [
  { key: "inicio", to: "/dashboard", label: "Inicio", icon: LayoutDashboard, match: ["/dashboard"] },
  { key: "movimientos", to: "/banco/movimientos", label: "Movimientos", icon: Landmark, match: ["/banco/movimientos"] },
  { key: "facturas", to: "/facturas/emitidas", label: "Facturas", icon: Receipt, match: ["/facturas"] },
  { key: "impuestos", to: "/impuestos", label: "Impuestos", icon: Percent, match: ["/impuestos"] },
  { key: "mas", to: "/mas", label: "Más", icon: MoreHorizontal, match: null },
];

export default function MobileNav() {
  const { pathname } = useLocation();
  const matches = (m) => Array.isArray(m) && m.some((p) => pathname.startsWith(p));
  const anyMatched = TABS.some((t) => matches(t.match));
  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 h-16 bg-white border-t border-slate-200 flex"
    >
      {TABS.map((t) => {
        const active = t.match ? matches(t.match) : !anyMatched;
        const Icon = t.icon;
        return (
          <NavLink
            key={t.key}
            to={t.to}
            data-testid={`mnav-${t.key}`}
            className={cn(
              "flex-1 min-h-[44px] flex flex-col items-center justify-center gap-0.5",
              active ? "text-blue-600" : "text-slate-400"
            )}
          >
            <Icon className="w-[22px] h-[22px]" strokeWidth={1.5} />
            <span className="text-[10.5px] font-semibold">{t.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
